<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Договор переоформлен с договора №</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="data?.reform_from" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const data = inject('data');
</script>
